import useSWR from "swr";


export const useFetchTotalRouletteCouponSegmentsByRestaurantId = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `games/roulette/restaurants/${restaurantId}/coupon/segments/counts/total` : null;
  const { data: totalCouponSegmentCount, error, isLoading } = useSWR<number>(fetcherKey)
  return { totalCouponSegmentCount, isLoading, error };
};

